import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  getPlayerSubscription,
  playerDiscountPackageAdd,
} from "../../services/academicService";
import {
  createRazorPayOrder,
  getPublicDiscountType,
  getPublicPlanType,
  razorPayOrderVerify,
} from "../../services/publicService";
import Swal from "sweetalert2";
import PlayerPaymentModal from "./PlayerPaymentModal";

const PlayerOnlinePaymentModal = ({
  show,
  onClose,
  userData,
  onPaymentSuccess,
}) => {
  const [packageData, setPackageData] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [formData, setFormData] = useState({
    amountDeposited: "",
    discountValue: "",
  });
  const [selectedDiscountType, setSelectedDiscountType] = useState(null);
  const [selectedPlanType, setSelectedPlanType] = useState(null);
  const [discountTypes, setDiscountTypes] = useState([]);
  const [planTypes, setPlanTypes] = useState([]);
  const [selectedDiscountApply, setSelectedDiscountApply] = useState({
    value: false,
    label: "No",
  });
  const [paymentModel, setPaymentModel] = useState(false);
  const [responseData, setResponseData] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (userData?.subscription && packageData.length) {
      const matchedPackage = packageData.find(
        (pkg) => pkg.id === userData.subscription.id,
      );

      setSelectedDiscountApply({
        value: userData?.playerSubscription?.isDiscount,
        label: userData?.playerSubscription?.isDiscount ? "Yes" : "No",
      });

      setFormData((prev) => ({
        ...prev,
        discountValue: userData?.playerSubscription?.discountValue || "",
      }));

      const discountType = discountTypes.find(
        (item) =>
          item.value === userData?.playerSubscription?.discountValueType,
      );

      setSelectedDiscountType(discountType || null);

      const planType = planTypes.find(
        (item) => item.value === userData?.playerSubscription?.discountType,
      );

      setSelectedPlanType(planType || null);

      if (matchedPackage) {
        setSelectedPackage({
          value: matchedPackage.id,
          label: `${matchedPackage.packageType?.name} (Amount : ${matchedPackage.ammount} INR)`,
        });
      }
    }
  }, [userData?.subscription?.id, packageData, show]);

  useEffect(() => {
    fetchPackage();
  }, []);

  async function fetchPackage() {
    try {
      const res = await getPlayerSubscription();
      setPackageData(res);
    } catch (error) {
      console.error("Error fetching package types:", error);
    }
  }

  const handleSubmit = async () => {
    const discountValue = Number(formData.discountValue || 0);

    if (!selectedPackage) {
      toast.error("Please select package");
      return;
    }

    if (selectedDiscountType?.value === "PERCENTAGE") {
      if (discountValue < 0 || discountValue > 100) {
        toast.error("Percentage must be between 0 and 100");
        return;
      }
    }

    if (discountValue > 0) {
      if (!selectedDiscountType) {
        toast.error("Please select Discount Type");
        return;
      }

      if (!selectedPlanType) {
        toast.error("Please select Plan Type");
        return;
      }
    }

    try {
      // CREATE ORDER API
      const payload = {
        subscriptionId: selectedPackage?.value,
        playerId: userData?.id,
        discountValue: Number(formData.discountValue),
        discountValueType: selectedDiscountType?.value,
        discountType: selectedPlanType?.value,
      };
      const response = await createRazorPayOrder(payload);
      // RAZORPAY
      const options = {
        image: "https://yourlogo.com/logo.png",
        key: response?.keyId,
        amount: response?.amount,
        currency: "INR",
        order_id: response?.orderId,
        name: "CrickPay",

        prefill: {
          email: userData?.email,
          contact: userData?.phone,
          name: userData?.name,
        },

        theme: {
          color: "#2563EB",
        },

        handler: async function (paymentResponse) {
          console.log("Payment Success :", paymentResponse);
          const res = await razorPayOrderVerify({
            playerId: userData?.id,
            razorpayOrderId: paymentResponse?.razorpay_order_id,
            razorpayPaymentId: paymentResponse?.razorpay_payment_id,
            razorpaySignature: paymentResponse?.razorpay_signature,
          });

          if (res) {
            onPaymentSuccess();
            toast.success("Payment Successful");
            resetForm();
            onClose();
          }
        },

        theme: {
          color: "#3399cc",
        },
      };

      const razor = new window.Razorpay(options);
      razor.open();
    } catch (error) {
      console.log(error);
      toast.error("Payment Failed");
    }
  };

  useEffect(() => {
    fetchDiscountTypes();
    fetchPlanTypes();
  }, []);

  async function fetchDiscountTypes() {
    try {
      const res = await getPublicDiscountType();
      setDiscountTypes(res);
    } catch (error) {
      console.error("Error fetching discount types:", error);
    }
  }

  async function fetchPlanTypes() {
    try {
      const res = await getPublicPlanType();
      setPlanTypes(res);
    } catch (error) {
      console.error("Error fetching plan types:", error);
    }
  }

  useEffect(() => {
    if (!selectedPackage) return;

    const pkg = packageData.find((item) => item.id === selectedPackage.value);

    const packageAmount = Number(pkg?.ammount || 0);
    const discountValue = Number(formData.discountValue || 0);

    let discountAmount = 0;

    if (selectedDiscountType?.value === "PERCENTAGE") {
      // Allow only 1-100%
      const percentage = Math.min(Math.max(discountValue, 0), 100);

      discountAmount = (packageAmount * percentage) / 100;
    } else {
      // Fixed amount
      discountAmount = discountValue;
    }

    const finalAmount = Math.max(packageAmount - discountAmount, 0);

    setFormData((prev) => ({
      ...prev,
      amountDeposited: finalAmount,
    }));
  }, [
    selectedPackage,
    formData.discountValue,
    selectedDiscountType,
    packageData,
  ]);

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setSelectedPackage(null);
    setSelectedDiscountType(null);
    setSelectedPlanType(null);

    setFormData({
      amountDeposited: "",
      discountValue: "",
    });
  };

  const handleAddDiscount = async () => {
    const discountValue = Number(formData.discountValue || 0);

    if (!selectedPackage) {
      toast.error("Please select package");
      return;
    }

    if (selectedDiscountType?.value === "PERCENTAGE") {
      if (discountValue < 0 || discountValue > 100) {
        toast.error("Percentage must be between 0 and 100");
        return;
      }
    }

    if (discountValue > 0) {
      if (!selectedDiscountType) {
        toast.error("Please select Discount Type");
        return;
      }

      if (!selectedPlanType) {
        toast.error("Please select Plan Type");
        return;
      }
    }
    try {
      const payload = {
        subscriptionId: selectedPackage?.value,
        playerId: userData?.id,
        amountDeposited: Number(formData.amountDeposited),
        isDiscount: selectedDiscountApply?.value,
        ...(selectedDiscountApply?.value && {
          discountValue: Number(formData.discountValue),
          discountValueType: selectedDiscountType?.value,
          discountType: selectedPlanType?.value,
        }),
      };
      const res = await playerDiscountPackageAdd(payload);
      if (res) {
        Swal.fire({
          title: "Package Configured!",
          text: "The package has been configured and assigned successfully.",
          icon: "success",
        });
        onPaymentSuccess();
        handleClose();
      }
    } catch (error) {
      console.error("Error applying discount:", error);
      Swal.fire(
        "Error",
        "An error occurred while applying the discount. Please try again.",
        "error",
      );
    }
  };

  const handlePackageChange = (selected) => {
    setSelectedPackage(selected);

    // Reset discount fields
    setSelectedDiscountApply({ value: false, label: "No" });
    setSelectedDiscountType(null);
    setSelectedPlanType(null);

    setFormData((prev) => ({
      ...prev,
      discountValue: "",
      amountDeposited: "",
    }));
  };

  useEffect(() => {
    if (!selectedPackage) return;

    if (selectedPackage.value === userData?.subscription?.id) {
      setSelectedDiscountApply({
        value: userData?.playerSubscription?.isDiscount,
        label: userData?.playerSubscription?.isDiscount ? "Yes" : "No",
      });

      setFormData((prev) => ({
        ...prev,
        discountValue: userData?.playerSubscription?.discountValue || "",
      }));

      const discountType = discountTypes.find(
        (x) => x.value === userData?.playerSubscription?.discountValueType,
      );
      setSelectedDiscountType(discountType || null);

      const planType = planTypes.find(
        (x) => x.value === userData?.playerSubscription?.discountType,
      );
      setSelectedPlanType(planType || null);
    }
  }, [selectedPackage, discountTypes, planTypes]);

  const handlePayNow = async () => {
    const discountValue = Number(formData.discountValue || 0);

    if (!selectedPackage) {
      toast.error("Please select package");
      return;
    }

    if (selectedDiscountType?.value === "PERCENTAGE") {
      if (discountValue < 0 || discountValue > 100) {
        toast.error("Percentage must be between 0 and 100");
        return;
      }
    }

    if (discountValue > 0) {
      if (!selectedDiscountType) {
        toast.error("Please select Discount Type");
        return;
      }

      if (!selectedPlanType) {
        toast.error("Please select Plan Type");
        return;
      }
    }
    try {
      const payload = {
        subscriptionId: selectedPackage?.value,
        playerId: userData?.id,
        amountDeposited: Number(formData.amountDeposited),
        isDiscount: selectedDiscountApply?.value,
        ...(selectedDiscountApply?.value && {
          discountValue: Number(formData.discountValue),
          discountValueType: selectedDiscountType?.value,
          discountType: selectedPlanType?.value,
        }),
      };
      const res = await playerDiscountPackageAdd(payload);
      if (res) {
        setResponseData(res);
        onPaymentSuccess();
        handleClose();
        setPaymentModel(true);
      }
    } catch (error) {
      console.error("Error applying discount:", error);
      Swal.fire(
        "Error",
        "An error occurred while paying. Please try again.",
        "error",
      );
    }
  };

  return (
    <>
      <Modal show={show} onHide={onClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Package Configration</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <div className="form-group col-sm-6">
              <label className="form-label">
                Select Package <span className="text-danger">*</span>
              </label>

              <Select
                isSearchable={false}
                options={packageData?.map((pkg) => ({
                  value: pkg?.id,
                  label: `${pkg?.packageType?.name} (${pkg?.ammount} INR)`,
                }))}
                placeholder="Select Package"
                value={selectedPackage}
                onChange={handlePackageChange}
              />
            </div>
            <div className="col-sm-6 ">
              <label className="form-label">
                Amount to be Deposited <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                name="amountDeposited"
                placeholder="Enter ammount to be deposited"
                className="form-control"
                value={formData.amountDeposited}
                onChange={handleChange}
                readOnly
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label className="form-label">
                  Discount Apply<span className="text-danger">*</span>
                </label>
                <Select
                  isSearchable={false}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  placeholder="Select Discount"
                  className="custom-react-select"
                  value={selectedDiscountApply}
                  onChange={setSelectedDiscountApply}
                />
              </div>
            </div>
            {/*  Discount */}
            {selectedDiscountApply.value === true && (
              <>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-label">
                      Discount Type <span className="text-danger">*</span>
                    </label>
                    <Select
                      isSearchable={false}
                      options={discountTypes?.map((mode) => ({
                        value: mode?.value,
                        label: mode?.label,
                      }))}
                      placeholder="Select Discount Type"
                      className="custom-react-select"
                      value={selectedDiscountType}
                      onChange={setSelectedDiscountType}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <label className="form-label">
                    Discount <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    name="discountValue"
                    placeholder={
                      selectedDiscountType?.value === "PERCENTAGE"
                        ? "Enter percentage (1-100)"
                        : "Enter discount amount"
                    }
                    className="form-control"
                    value={formData.discountValue}
                    onChange={handleChange}
                  />
                </div>

                {/*  Discount Limitation */}
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-label">
                      Plan Type <span className="text-danger">*</span>
                    </label>
                    <Select
                      isSearchable={false}
                      options={planTypes?.map((mode) => ({
                        value: mode?.value,
                        label: mode?.label,
                      }))}
                      placeholder="Select Plan Type"
                      className="custom-react-select"
                      value={selectedPlanType}
                      onChange={setSelectedPlanType}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant={
              userData?.paymentStatus?.Unpaid ? "primary" : "outline-info"
            }
            onClick={handleAddDiscount}
          >
            Save
          </Button>
          {!userData?.paymentStatus?.Unpaid && (
            <Button variant="primary" onClick={handlePayNow}>
              Pay Now
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <PlayerPaymentModal
        show={paymentModel}
        onClose={() => setPaymentModel(false)}
        userData={responseData}
        onPaymentSuccess={() => {
          setPaymentModel(false);
          onPaymentSuccess();
        }}
      />
    </>
  );
};

export default PlayerOnlinePaymentModal;
